export default __webpack_public_path__ + "static/media/prevention-of-sexual-harrasment-policy-updated.38622fec.pdf";